// The server's slowed copy is time-stretched to this speed (ffmpeg atempo).
export const SLOW_AUDIO_SERVER_SPEED = 0.85;

class SlowAudioService {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
  }

  fetch(contentType, contentId, audioUrl, chatMessageId = null) {
    // Build the request body, only including audio_url if it's not null
    const requestBody = {
      content_type: contentType,
      content_id: contentId,
      speed: SLOW_AUDIO_SERVER_SPEED,
      chat_message_id: chatMessageId,
      // Audio made for a reply without any becomes its own; web applies an
      // Eleven v4 reply's playback rate (LAN-1177)
      ttsPlaybackRate: true
    };

    // Only add audio_url if it has a value
    if (audioUrl) {
      requestBody.audio_url = audioUrl;
    }

    return fetch('/langua/slow_audio', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      credentials: 'same-origin',
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
  }
}

export default SlowAudioService
